module.exports = __webpack_public_path__ + "img/why-keyapl-3.b64bf2ab.png";